const REDIRECTS = ['/index.html', '/index.htm'];

export default REDIRECTS;
